import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class FirSanctionedCountriesService {

  constructor(private http: HttpClient) {}

  loadJsonObject(baseUrl: string, params: Record<string, any>): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });
    return this.http.get<any>(`${url}?${urlEncoded.toString()}`, { withCredentials: true });
  }

  saveSanctionedCountries(
    baseUrl: string,
    jsonObj: any[],
    jsonSettings: any[],
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=vp3h7r`;

    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({ jsonSettings: JSON.stringify(jsonSettings) }, params);
    params = _.extend({ jsonObj: JSON.stringify(jsonObj) }, params);

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
